// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L0hC","title":"styles_title__3nVQ5"};